import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import SalesCatalystSectionBottom from '../SalesCatalystSectionBottom';
import BarChart from '../../common/BarChart';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';

import { SC_BRAND_REPORT, DISPLAY_BRAND_CHART_COUNT } from '../../../constants';
import { numberWithCommas, getFiltersForGivenFamilyId } from '../../../util/CommonUtils';
import { SALES_CATALYST_BRAND_CHART_HEADER, NO_DATA_AVAILABLE_MSG } from '../../../messages/messages';
import { getColorCodeForGivenCategory, createSubCategoryArray } from '../../../util/SalesCatalystUtils';
import filterIconActive from '../../../images/insight360/filter-icon_active.png';
import FilterSearchComponent from '../../common/FilterSearchComponent';
import clearIcon from '../../../images/insight360/clear-field-icon_190-190-190.png';

class SalesCatalystBrandBarChart extends React.Component {
  constructor(props) {
    super(props);
    const subCategories = this.props.selectedFilters !== undefined
    ? getFiltersForGivenFamilyId(this.props.selectedFilters,
      this.props.studyFamilyId)
    : [];
    this.state = {
      displayBarChartCount: DISPLAY_BRAND_CHART_COUNT,
      showFilterSearch: false,
      subCategories,
      selectedFilter:
        this.props.selectedFilters !== undefined
          ? this.props.selectedFilters
          : [],
    };
  }

  componentDidMount() {
    const { targetOnScreen, graphData, getBrandBarChartData, selectedFilters, studyFamilyId } = this.props;

    if (targetOnScreen && _.isEmpty(graphData.scBrands)) {
      const subCategories = createSubCategoryArray(getFiltersForGivenFamilyId(selectedFilters,
        studyFamilyId));
      getBrandBarChartData(SC_BRAND_REPORT,
        undefined, undefined, undefined, subCategories);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { targetOnScreen, getBrandBarChartData, dataSelection, selectedFilters } = this.props;
    if (!targetOnScreen && nextProps.targetOnScreen && dataSelection.targetMarket.length > 0 &&
      dataSelection.entity.length > 0) {
      const subCategoriesList = createSubCategoryArray(getFiltersForGivenFamilyId(nextProps.selectedFilters,
        nextProps.studyFamilyId));
      getBrandBarChartData(SC_BRAND_REPORT,
        undefined, undefined, undefined, subCategoriesList);
      this.setState({
        displayBarChartCount: DISPLAY_BRAND_CHART_COUNT });
    }
    if (selectedFilters !== nextProps.selectedFilters) {
      const subCategories = getFiltersForGivenFamilyId(nextProps.selectedFilters,
        nextProps.studyFamilyId);
      this.setState({
        selectedFilter: nextProps.selectedFilters,
        subCategories,
      });
    }
  }

  getColorCode= overlapPercentage => {
    const brand = getColorCodeForGivenCategory('BRAND');
    const brandOverlap = getColorCodeForGivenCategory('BRANDOVERLAP');
    const color = `${`linear-gradient(to right,${brandOverlap}0%,${brandOverlap}${overlapPercentage.toString()
    }, ${brand} 0%, ${brand} 100%)`}`;
    return color;
  }

  findBarWidth= (highestWeighted, currentWeight) => {
    let widthPercentage = 0;
    widthPercentage = Math.round((currentWeight * 100) / highestWeighted);
    if (widthPercentage < 16) {
      widthPercentage = 17;
    }
    return widthPercentage;
  }

  findWeightedLeftPadding= (highestWeighted, currentWeight) => {
    const widthPercentage = this.findBarWidth(highestWeighted, currentWeight);
    let leftPadding = 0;

    if (widthPercentage <= 20) {
      leftPadding = widthPercentage + 2;
      return leftPadding;
    }

    if (widthPercentage <= 30) {
      leftPadding = widthPercentage + 1.5;
      return leftPadding;
    }

    if (widthPercentage < 60) {
      leftPadding = widthPercentage + 1;
      return leftPadding;
    }
    return leftPadding;
  }

  increaseDisplayBarChartCount = () => {
    this.setState({
      displayBarChartCount: this.state.displayBarChartCount + DISPLAY_BRAND_CHART_COUNT,
    });
  }

  closeFilterBox = () => {
    this.setState({
      showFilterSearch: false,
    });
  };

  searchFilterFn = (searchVal, callback) => {
    this.props.getfilterSearchResult(
      this.props.componentInfo.category,
      searchVal,
      callback,
    );
  };

  applyFilterFn = filters => {
    const { saveSelectedFilters, getBrandBarChartData, componentInfo } = this.props;
    this.setState({
      showFilterSearch: false,
    });
    if (filters !== '') {
      const subCategories = createSubCategoryArray(filters);
      const modifiedFilters = this.updateFiltersList(filters);
      saveSelectedFilters(modifiedFilters, componentInfo.category);
      getBrandBarChartData(SC_BRAND_REPORT,
        undefined, undefined, undefined, subCategories);
    }
  };

  updateFiltersList = filters => {
    const { selectedFilters, studyFamilyId } = this.props;

    let modifiedFilters = [];
    if (selectedFilters !== undefined && _.isArray(selectedFilters) && selectedFilters.length > 0) {
      const filter = selectedFilters[0];
      if (filter.studyFamilyId !== undefined) {
        modifiedFilters = _.cloneDeep(selectedFilters);
      }
    }
    const index = _.findIndex(modifiedFilters, { studyFamilyId });
    if (index >= 0) {
      modifiedFilters[index] = { studyFamilyId, filters };
    } else {
      modifiedFilters.push({ studyFamilyId, filters });
    }
    return modifiedFilters;
  }

  removeFilterFn = filterVal => {
    const { subCategories } = this.state;
    const selFilters = _.cloneDeep(subCategories);
    const itemIndex = _.findIndex(selFilters, { value: filterVal });
    selFilters.splice(itemIndex, 1);
    this.applyFilterFn(selFilters);
  };

  getToolTip = data => {
    return (
      <span
        style={{
          whiteSpace: 'nowrap',
          border: 'black',
          fontSize: '11px',
          color: 'black',
          textAlign: 'left',
          alignSelf: 'stretch',
          display: 'block',
        }}
      >
        SAMPLE: <b>{numberWithCommas(Math.round(data.details[0].sample))}</b><br />
        WEIGHTED: <b>{numberWithCommas(Math.round(data.details[0].weighted))}</b><br />
        INDEX: <b>{numberWithCommas(Math.round(data.details[0].index))}</b>
      </span>
    );
  }

  render() {
    const { brands, graphData, title, highestWeighted } = this.props;
    return (
      (graphData.scBrands.groups !== undefined) && <div className="row fullWidth sub-entity-block-section brand-graph-block-margin">
        <div className="large-12 medium-12 small-12 columns header-block">
          <div className="header-text" title={title}>
            {SALES_CATALYST_BRAND_CHART_HEADER} {graphData.scBrands.groups[0]}
          </div>
          <span className="sc-category-filter-ico">
            <img
              className="sc-icon-img-cp-wp"
              src={filterIconActive}
              alt="filter"
              onClick={() =>
                this.setState({
                  showFilterSearch: !this.state.showFilterSearch,
                })
              }
            />
            {this.state.showFilterSearch && (
              <FilterSearchComponent
                searchFilterFn={this.searchFilterFn}
                applyFilterFn={this.applyFilterFn}
                selectedFilter={this.state.subCategories}
                closeFilterBox={this.closeFilterBox}
                additionalStyles={{ right: '0' }}
              />
            )}
          </span>
        </div>
        <div className="large-12 medium-12 small-12 columns" style={{ paddingBottom: '1%' }}>
          <div className="sc-category-filter-display">
            {this.state.subCategories.length > 0 &&
              this.state.subCategories.map(selFilter => (<span
                className="category-filter-item overflow-i"
                key={selFilter.value}
              >
                <img
                  className="sc-icon-img-cp-wp"
                  src={clearIcon}
                  alt="Remove"
                  onClick={() => {
                    this.removeFilterFn(selFilter.value);
                  }}
                />
                {selFilter.label}
              </span>
              )
              )}
          </div>
          {brands.length > 0 ?
          _.take(brands, this.state.displayBarChartCount).map((brand, index) => {
            return (
              <BarChart
                index={index}
                background={getColorCodeForGivenCategory('BRAND')}
                width={`${this.findBarWidth(highestWeighted, brand.details[0].weighted)}%`}
                data={brand}
                toolTipContent={() => {
                  return this.getToolTip(brand);
                }}
              />
            );
          }) : <div className="text-align-center margin-top-10">
            <p>{NO_DATA_AVAILABLE_MSG}</p>
          </div>}
        </div>
        {(brands.length > this.state.displayBarChartCount) && <div className="large-12 medium-12 small-12 columns margin-bottom-5">
          <button type="button" className="sub-entity-more-button" onClick={this.increaseDisplayBarChartCount}>
            More
          </button>
        </div>
      }
        <div className="padding-10">
          <SalesCatalystSectionBottom />
        </div>
      </div>
    );
  }
}

SalesCatalystBrandBarChart.propTypes = {
  graphData: PropTypes.shape({}),
  targetOnScreen: PropTypes.bool,
  getBrandBarChartData: PropTypes.func,
  dataOnScreenTarget: PropTypes.shape({}),
  brands: PropTypes.instanceOf(Array),
  title: PropTypes.string,
  highestBrandWeighted: PropTypes.instanceOf(Object),
  getfilterSearchResult: PropTypes.func,
  componentInfo: PropTypes.shape({
    category: PropTypes.string,
  }),
  highestWeighted: PropTypes.instanceOf(Object),
};

function mapStateToProps(state) {
  let highestWeighted = {};
  if (typeof state.salesCatalyst.graphData.scBrands.subEntities !== 'undefined') {
    highestWeighted = _.maxBy(state.salesCatalyst.graphData.scBrands.subEntities,
      subEntity => {
        return subEntity.details[0].weighted;
      }).details[0].weighted;
  }
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    studyFamilyId: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.studyFamilyId !== 'undefined' ?
      state.study.salesCatalystStudy.studyFamilyId : -1,
    dataSelection: state.salesCatalyst.dataSelection,
    targetOnScreen: state.salesCatalyst.dataOnScreen.targetMarket,
    graphData: state.salesCatalyst.graphData,
    brands: typeof state.salesCatalyst.graphData.scBrands.subEntities !== 'undefined' ?
      state.salesCatalyst.graphData.scBrands.subEntities : [],
    highestWeighted,
    entityTargetOverlap: (state.salesCatalyst.dataSelection.targetMarket.length > 0 &&
        state.salesCatalyst.dataSelection.entity.length > 0)
        ? `${state.salesCatalyst.dataSelection.targetMarket[0].label} AND ${state.salesCatalyst.dataSelection.entity[0].label}` : '',
    entityTargetExpression: (state.salesCatalyst.dataSelection.targetMarket.length > 0 &&
          state.salesCatalyst.dataSelection.entity.length > 0)
          ? `${state.salesCatalyst.dataSelection.targetMarket[0].expression} AND ${state.salesCatalyst.dataSelection.entity[0].expression}` : '',
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;
/*
  const getBrandBarChartData = (report, vpctFilter, top) => {
    const personaLabels = [];
    const personaExpressions = [];
    const productNo = stateProps.productNo;
    const token = stateProps.loginResponse.data.token;
    const uid = stateProps.loginResponse.data.uid;
    const accountId = stateProps.activeAccountId;
    const reportName = report;
    personaLabels.push(stateProps.entityTargetOverlap);
    personaExpressions.push(stateProps.entityTargetExpression);

    dispatch(salesCatalystActions.getBrandBarChartReport({
      uid,
      accountId,
      token,
      reportName,
      productNo,
      personaLabels,
      personaExpressions,
      vpctFilter,
      top,
    }));
  };*/

  const getBrandBarChartData = (report, vpctFilter, top, minSampleSize, subCategories) => {
    const productNo = stateProps.productNo;
    const token = stateProps.loginResponse.data.token;
    const uid = stateProps.loginResponse.data.uid;
    const accountId = stateProps.activeAccountId;
    const reportName = report;
    const targetLabel = stateProps.dataSelection.targetMarket[0].label;
    const targetExpression = stateProps.dataSelection.targetMarket[0].expression;
    const entityLabel = stateProps.dataSelection.entity[0].label;
    const entityExpression = stateProps.dataSelection.entity[0].expression;
    const brandLabel = stateProps.dataSelection.brand.length !== 0 ?
      stateProps.dataSelection.brand[0].label : '';
    const brandExpression = stateProps.dataSelection.brand.length !== 0 ?
    stateProps.dataSelection.brand[0].expression : '';
    const sortBy = 'pct';
    dispatch(salesCatalystActions.getBarChartReport({
      uid,
      accountId,
      token,
      reportName,
      productNo,
      targetLabel,
      targetExpression,
      entityLabel,
      entityExpression,
      brandLabel,
      brandExpression,
      vpctFilter,
      top,
      minSampleSize,
      sortBy,
      subCategories,
    }));
  };

  const saveSelectedFilters = (value, key) => {
    dispatch(salesCatalystActions.saveTargetFilterData(value, key));
  };

  return Object.assign({}, stateProps, ownProps, {
    getBrandBarChartData,
    saveSelectedFilters,
  });
};
export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystBrandBarChart);
